module.exports = __webpack_public_path__ + "static/media/cq_percentuale_blu.1cef4413.svg";